<template>
    <section class="tab-pane">
      <section class="detailed-analysis">
        <section v-if="hasRuleCompliance" class="analysis-section">
          <header class="section-header">
            <h4>
              <i class="fas fa-clipboard-check"></i>
              {{ t('relatorio_conformidade_regras') }}
              <span class="counter-badge">{{ compliantCount }}/{{ ruleCompliance.length }}</span>
            </h4>
          </header>
          <section class="items-list">
            <article
              v-for="(rule, ruleIndex) in ruleCompliance"
              :key="`${rule.ruleId}-${ruleIndex}`"
              class="list-item"
              :class="getDictionary(rule.status, 'ruleStatus', 'class')"
            >
              <button
                type="button"
                class="rule-accordion-header"
                @click="toggleRule(rule.ruleId, ruleIndex)"
              >
                <div class="item-header">
                  <div
                    class="item-icon"
                    :class="getDictionary(rule.status, 'ruleStatus', 'class')"
                  >
                    <i class="fas fa-fw" :class="getDictionary(rule.status, 'ruleStatus', 'icon')"></i>
                  </div>
                  <div class="item-content">
                    <div class="item-title">{{ rule.ruleName || resolveRuleLabel(rule.ruleId) }}</div>
                    <div class="item-description">{{ rule.details || t('relatorio_sem_detalhes') }}</div>
                  </div>
                </div>
                <div class="issue-header-right">
                  <span
                    class="accordion-chevron"
                    :key="`rule-chevron-${rule.ruleId}-${ruleIndex}-${isRuleExpanded(rule.ruleId, ruleIndex) ? 'open' : 'closed'}`"
                    :title="isRuleExpanded(rule.ruleId, ruleIndex) ? t('relatorio_recolher') : t('relatorio_expandir')"
                    :aria-label="isRuleExpanded(rule.ruleId, ruleIndex) ? t('relatorio_recolher') : t('relatorio_expandir')"
                  >
                    <i
                      class="fas"
                      :class="isRuleExpanded(rule.ruleId, ruleIndex) ? 'fa-chevron-down' : 'fa-chevron-right'"
                    ></i>
                  </span>
                </div>
              </button>
  
              <div
                v-if="isRuleExpanded(rule.ruleId, ruleIndex)"
                class="rule-accordion-body"
              >
                <div class="entity-grid">
                  <div class="entity-line">
                    <strong>{{ t('relatorio_status') }}:</strong>
                    <span>{{ getDictionary(rule.status, 'ruleStatus') }}</span>
                  </div>
                  <div v-if="rule.severityIfViolated" class="entity-line">
                    <strong>{{ t('relatorio_severidade_se_violada') }}:</strong>
                    <span>{{ getDictionary(rule.severityIfViolated, 'severity') }}</span>
                  </div>
                </div>
                <div class="entity-actions">
                  <button
                    v-if="hasIssueForRule(rule.ruleId)"
                    type="button"
                    class="navigate-btn"
                    @click="$emit('open-issue-from-rule', rule.ruleId)"
                  >
                    {{ t('relatorio_ir_para_problema') }}
                  </button>
                  <span v-else class="entity-empty">
                    {{ t('relatorio_sem_problema_relacionado') }}
                  </span>
                </div>
              </div>
            </article>
          </section>
        </section>
  
        <div v-if="!hasRuleCompliance" class="no-data-message">
          <i class="fas fa-check-circle"></i>
          <p>{{ t('relatorio_sem_analise_detalhada') }}</p>
        </div>
      </section>
    </section>
  </template>
  
  <script>
  import { getDictionary, resolveRuleLabel } from './relatorioIA.js';
  
  export default {
    name: 'RelatorioComplianceTab',
    props: {
      ruleCompliance: { type: Array, required: true },
      expandedRules: { type: Object, default: () => ({}) },
      compliantCount: { type: Number, default: 0 },
      hasIssueForRule: {
        type: Function,
        required: true
      }
    },
    computed: {
      hasRuleCompliance() {
        return this.ruleCompliance && this.ruleCompliance.length > 0;
      }
    },
    methods: {
      t(key, params) {
        return this.$t(key, params);
      },
      toggleRule(ruleId, index) {
        this.$emit('toggle-rule', { ruleId, index });
      },
      isRuleExpanded(ruleId, index) {
        return !!this.expandedRules[`${ruleId}-${index}`];
      },
      getDictionary,
      resolveRuleLabel
    }
  };
  </script>